import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '2rem',
        background: '#0c0b0e',
        color: '#f4f1ea',
        textAlign: 'center',
      }}
    >
      <div>
        <p style={{ color: '#d4a853', fontFamily: 'monospace' }}>404</p>
        <h1>That page is not in this draft.</h1>
        <p style={{ color: '#b7b2a8' }}>The address may have changed, or the page may no longer exist.</p>
        <Link style={{ color: '#d4a853' }} to="/">
          Return to BeatBandit
        </Link>
      </div>
    </main>
  );
}
